<template>
  <exchange-log
    :exchanges="exchanges"
    :loading="loading"
    :loaded="loaded"
    title="Запросы к Delivery по этому заказу"
    empty-hint="Переписки нет. Она пишется, только когда включена настройка «Записывать переписку с Delivery» в системных настройках, на вкладке Delivery."
    @refresh="refresh"
  ></exchange-log>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ExchangeLog from '@/components/exchange-log.vue'

export default {
  name: 'OrderDeliveryLog',
  components: { ExchangeLog },
  computed: {
    ...mapState('orderDeliveryLog', ['exchanges', 'loading', 'loaded']),
  },
  async mounted() {
    await this.refresh()
  },
  methods: {
    ...mapActions('orderDeliveryLog', ['fetchLog']),
    async refresh() {
      const { id } = this.$route.params
      await this.fetchLog(id)
    },
  },
}
</script>
